import { compose } from 'recompose';

import SubscriberEdit from './SubscriberEdit';

const enhance = compose();

export default enhance(SubscriberEdit);
